import { useTranslation } from "react-i18next";
import { getCanonicalTitle } from "../../../../../common/util/Incentives/IncentiveRegistry";
import { ActionCard } from "../../ActionCard/ActionCard";
import defaultContent from "../../../../../content/groupManagement";
import { ROUTE_PATHS } from "../../../../../common/enums/routing-enums";
import TEALIUM from "../../../../../common/enums/tealium-enums";
import { track } from "../../../../../common/util/tealium";
import { CardComponentProps } from "../ActionCenter";

export const CvrComplianceCard = ({ enabled }: CardComponentProps) => {
  const { t } = useTranslation(["groupManagement"]);

  const handleTracking = () => {
    track(
      TEALIUM.U_TAG_METHOD.LINK,
      TEALIUM.EVENT_NAME.CLICK_ACTION,
      TEALIUM.CATEGORY.GROUP_MANAGEMENT,
      "cvr-compliance_action_report",
      "",
      "cvr_compliance",
    );
  };

  const cardTitle = getCanonicalTitle({ id: "cvrCompliance" }, t, {});

  return (
    <ActionCard
      title={cardTitle}
      to={ROUTE_PATHS.CVR}
      disabled={!enabled}
      headerOnly
      onClickTracking={handleTracking}
    />
  );
};
